// ===========================================================================
// Provider Performance & Scorecards (Module M) — capa de datos.
//
// Hoy sirve fake data determinístico (fakeData.js); cuando exista
// analytics.TAB_PROVIDER_SCORECARD se reemplaza por:
//   GET /api/analytics/provider-scorecards?period=YYYY-MM
// ===========================================================================

import { FAKE_PROVIDERS } from "./fakeData";

/**
 * Definición de métricas del scorecard.
 * - higherIsBetter: dirección del delta vs peer
 * - max: escala para las barras comparativas
 * - fmt: formateo del valor
 */
export const SCORECARD_METRICS = [
  { key: "rafScore", label: "RAF score", higherIsBetter: true, max: 2, fmt: (v) => v.toFixed(2) },
  { key: "codingSpecificity", label: "Coding specificity", higherIsBetter: true, max: 100, fmt: (v) => `${v.toFixed(1)}%` },
  { key: "hccRecaptureRate", label: "HCC recapture", higherIsBetter: true, max: 100, fmt: (v) => `${v.toFixed(1)}%` },
  { key: "gapClosureRate", label: "Care gap closure", higherIsBetter: true, max: 100, fmt: (v) => `${v.toFixed(1)}%` },
  { key: "awvCompletion", label: "AWV completion", higherIsBetter: true, max: 100, fmt: (v) => `${v.toFixed(1)}%` },
  { key: "postDischargeFollowUp", label: "Post-discharge follow-up (7d)", higherIsBetter: true, max: 100, fmt: (v) => `${v.toFixed(1)}%` },
  { key: "chargeLagDays", label: "Charge lag (days)", higherIsBetter: false, max: 10, fmt: (v) => v.toFixed(1) },
  { key: "visitsPerDay", label: "Visits per day", higherIsBetter: true, max: 24, fmt: (v) => v.toFixed(1) },
];

/** Promedio simple de una métrica sobre la lista de providers. */
const avg = (providers, key) =>
  providers.reduce((acc, p) => acc + p[key], 0) / (providers.length || 1);

/**
 * Carga providers + promedios peer del grupo.
 *
 * @returns {Promise<Object>} {
 *   providers: [...scorecards],
 *   peerAverages: { rafScore, codingSpecificity, ... },
 *   signals: { providerCount, avgRaf, avgSpecificity, avgGapClosure, avgChargeLag }
 * }
 */
export async function getProviderPerformance() {
  // Simula latencia de red mínima para ejercitar el loading state.
  const providers = [...FAKE_PROVIDERS].sort((a, b) => b.rafScore - a.rafScore);

  const peerAverages = {};
  SCORECARD_METRICS.forEach((m) => {
    peerAverages[m.key] = avg(providers, m.key);
  });

  return {
    providers,
    peerAverages,
    signals: {
      providerCount: providers.length,
      avgRaf: peerAverages.rafScore,
      avgSpecificity: peerAverages.codingSpecificity,
      avgGapClosure: peerAverages.gapClosureRate,
      avgChargeLag: peerAverages.chargeLagDays,
    },
  };
}
